import React from 'react';
import { Grid, Title, Col } from '@common/components';
import gridClasses from './GridSampleView.module.scss';

export default function GridSampleView() {
  const testData = Array.from(Array(12).keys());

  return (
    <div className={gridClasses.grid}>
      <Title type="h1">Grid demo</Title>
      <Grid>
        {testData.map((item) => (
          <Col
            className={gridClasses.col}
            key={`item_${item}`}
            xss={12}
            xs={6}
            sm={4}
            lg={2}
            xl={1}
          >
            {item + 1}
          </Col>
        ))}
      </Grid>
    </div>
  );
}
